import { createBrowserHistory } from 'history';
import { isRacker } from '@rss-engineering/fabric-ui-session';

let basename = '/tickets';
if(process.env.PUBLIC_URL) {
  basename = process.env.PUBLIC_URL;
} 
if (isRacker()) {
  const currentUrl = window.location.href.split('/');
  const urlDomainId = currentUrl[currentUrl.indexOf('racker') + 1];
  basename += `/racker/${urlDomainId}`;
}

// To check APIs in dev env commenting domainID for now
const history = createBrowserHistory({
  basename
});

export { history };
